enum IconName {
  ARROW_RIGHT = 'arrowRight',
  SIGN_IN_ALT = 'signIn',
  CHECK = 'check',
  QUOTE = 'quote',
  CALENDAR = 'calendar',
}

export { IconName };
